import { Box, Typography, Button, Card } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useRef } from "react";
import { ConfettiButton } from "../../../components/Confetti/Confetti";
import confetti from "canvas-confetti";
import { useNavigate } from "react-router-dom";
import { ArrowForward } from "@mui/icons-material";
import { ISubscriptionPlan } from "../../../redux/subscription/subscription.types";
import { Paper } from "@mui/material";

const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 400,
  margin: "0 auto",
  padding: theme.spacing(4),
  borderRadius: 20,
  textAlign: "center",
  backgroundColor: "#f8f9ff",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  position: "relative",
  overflow: "visible",
}));

const ShareButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#1682D4",
  color: "white",
  borderRadius: 25,
  padding: "8px 40px",
  textTransform: "none",
  fontSize: 16,
  fontWeight: 600,
  marginTop: theme.spacing(3),
}));

export const Congratulations = ({
  viewPlan,
}: {
  viewPlan: ISubscriptionPlan | null;
}) => {
  const confettiRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    // Fire confetti automatically when component mounts
    const fireConfetti = async () => {
      try {
        // Ensure we're working with the main document canvas
        const canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = '9999';
        document.body.appendChild(canvas);

        const myConfetti = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        // Multiple confetti bursts for celebration effect
        await myConfetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
          colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff']
        });
        
        // // Second burst with different settings
        // setTimeout(async () => {
        //   await myConfetti({
        //     particleCount: 50,
        //     angle: 60,
        //     spread: 55,
        //     origin: { x: 0, y: 0.6 },
        //     colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff']
        //   });
        // }, 50);
        
        // // Third burst from the other side
        // setTimeout(async () => {
        //   await myConfetti({
        //     particleCount: 50,
        //     angle: 120,
        //     spread: 55,
        //     origin: { x: 1, y: 0.6 },
        //     colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff']
        //   });
        // }, 50);

        // Clean up canvas after animation
        setTimeout(() => {
          if (canvas && canvas.parentNode) {
            canvas.parentNode.removeChild(canvas);
          }
        }, 3000);

      } catch (error) {
        console.error("Confetti error:", error);
      }
    };

    // Longer delay to ensure dialog/modal is fully rendered and visible
    const timer = setTimeout(fireConfetti, 200);
    
    return () => clearTimeout(timer);
  }, []);
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        padding: 2,
      }}
    >
      <Paper
        sx={{
          maxWidth: 500,
          margin: "0 auto",
          borderRadius: 5,
          padding: 5,
          textAlign: "center",
          backgroundColor: "#fff",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          position: "relative",
          overflow: "visible",
        }}
      >
        <div className="relative">
          <ConfettiButton>
            <img
              src="https://static.vecteezy.com/system/resources/previews/022/891/556/large_2x/confetti-and-tinsel-explosion-background-realistic-ribbon-and-confetti-colorful-confetti-isolated-on-transparent-background-carnival-elements-birthday-party-celebration-free-png.png"
              alt=""
              style={{
                width: "20rem",
                rotate: "-30deg",
              }}
            />
          </ConfettiButton>
        </div>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            textAlign: "center",
            color: "#1682D4", 
            fontWeight: 700,
            marginBottom: 2,
            fontSize: 34,
          }}
        >
          Congratulations!
        </Typography>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#2d3748",
            marginBottom: 2,
            fontSize: 18,
          }}
        >
          You have successfully subscribed to{" "}
          {viewPlan?.plan_name || "our service"}.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#718096",
            lineHeight: 1.6,
            fontSize: 14,
            maxWidth: 780,
            margin: "0 auto",
          }}
        >
          Let's go to dashboard and start using all the features included in
          your subscription plan.
        </Typography>

        <ShareButton
          onClick={() => navigate("/dashboard")}
        variant="contained" size="large">
          Go to Dashboard 
          <ArrowForward />
        </ShareButton>
      </Paper>
    </Box>
  );
};
